export default __webpack_public_path__ + "static/1-d842013bc63466e0bf2c96f9a1410cc6.jpeg";